import { DiscountCodeType, DiscountGroup } from "@/primary-models";
import { ISubscriptionAppliedDiscount } from "@api-clients/subscriptions";
import { formatCurrency } from "libs/i18n/src/lib/currency";

export type DiscountSign = "POSITIVE" | "NEGATIVE";

export interface IDiscount {
  type: "FIXED_REDUCTION" | "PERCENTAGE_REDUCTION" | "FIXED_ABSOLUTE" | undefined;
  value: number; // Behaviour of value should vary depending on the type of discount
}

const handleDiscountSign = (sign: DiscountSign): string => (sign === "NEGATIVE" ? "-" : "");

export function getDiscountAsString(discount: IDiscount, sign: DiscountSign = "POSITIVE"): string {
  if (discount.type === "PERCENTAGE_REDUCTION") return `${handleDiscountSign(sign)}${discount.value}%`;
  return `${handleDiscountSign(sign)}£${discount.value.toFixed(2)}`;
}

/** Used in the AP for discount group selectors */
export type TDiscountGroupRef = Pick<DiscountGroup, "id" | "name">;

/** The group every influencer code belongs to. Both values are hardcoded from production
 * and are not guaranteed to match other environments, where the group may have a different
 * id or name. Ticket TECH-3234 covers fixing this. Prefer a group fetched from
 * the API wherever one is available. */
export const INFLUENCER_GROUP: TDiscountGroupRef = {
  id: 12,
  name: "Influencer Discount",
};

export const isValidFreeBoxInfluencerCode = (amount: number, type: DiscountCodeType, groupId: number | null):
{ success: boolean, error?: string } => {
  if (type !== DiscountCodeType.PERCENTAGE || amount < 100) {
    return { success: false, error: "Discount code is not valid" };
  }

  if (groupId !== INFLUENCER_GROUP.id) {
    return { success: false, error: "Discount code is not for influencers" };
  }

  return { success: true };
};


export const getDiscountValueFromType = (discount: ISubscriptionAppliedDiscount) => (
  discount.type === "PERCENTAGE"
    ? `${Math.round(+discount.amount)}%`
    : formatCurrency(discount.amount, "en")
);
